import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { deleteRow, listCollection, type Row } from '../../lib/db';
import { useToast } from '../../components/Toast';

export function ServiceList() {
  const [rows, setRows] = useState<Row[]>([]);
  const [loading, setLoading] = useState(true);
  const { notify } = useToast();

  const load = () =>
    listCollection('services', 'createdAt').then((r) => {
      setRows(r);
      setLoading(false);
    });
  useEffect(() => {
    void load();
  }, []);

  const remove = async (id: string) => {
    if (!confirm('Delete this service?')) return;
    await deleteRow('services', id);
    notify('success', 'Service deleted.');
    void load();
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="fw-bold m-0">Services</h3>
        <Link to="/services/new" className="btn btn-success btn-sm">
          New service
        </Link>
      </div>
      {loading ? (
        <p className="text-muted">Loading…</p>
      ) : (
        <table className="table table-hover">
          <thead>
            <tr>
              <th>Title (BG)</th>
              <th>Type</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => {
              const title = (r.title ?? {}) as { bg?: string; en?: string };
              return (
                <tr key={r.id}>
                  <td>{title.bg || title.en || '—'}</td>
                  <td>{String(r.type ?? '')}</td>
                  <td className="text-end">
                    <Link to={`/services/${r.id}`} className="btn btn-sm btn-outline-secondary me-2">
                      Edit
                    </Link>
                    <button className="btn btn-sm btn-outline-danger" onClick={() => remove(r.id)}>
                      Delete
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </>
  );
}
